module.exports = __webpack_public_path__ + "img/tiktok_default_thumbnail.32b2fa1e.png";